import React, {Component} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames';
import querystring from 'query-string'
import autobind from 'autobind-decorator'
import ItemAllCheckbox from '../../common/EntryItemAllCheckbox';
import { jsonResponseHandler } from '../../../utils/FetchHelper'
import { parseListParams } from '../../common/EntryListHelper';
import { selectAllItems, deselectAllItems, updateSelectedItems, receiveItems  } from '../../../actions/contents/template'
import WindowEventHelper from "../../../lib/WindowEventHelper";
import TSelectFilter from "../../common/TSelectFilter";
import {addPrefix} from "../../../utils/UriUtil";
import EntryHeaderSearchButton from "../EntryHeaderSearchButton"

@connect(state => ({
  items: state.template.item.items,
  searchKeyword: state.template.condition.searchKeyword,
  searchType: state.page.condition.searchType,
}), dispatch => ({
  handleSelectAllItems: () => {
    dispatch(selectAllItems())
  },
  handleDeselectAllItems: () => {
    dispatch(deselectAllItems())
  },
  handleUpdateSelectedItems: (values) => {
    dispatch(updateSelectedItems(values))
  },
  handleReceiveItems: (items, totalCount) => {
    dispatch(receiveItems(items, totalCount))
  },
  dispatch
}))
class TemplateListHeader extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      optionOpen: false,
      searchOpen: false,
      deleting: false,
      searching: false,
      searchKeyword : '',
      searchType : 'title',
      searchTypeOptions : [{ label : '제목', value: 'title'}, { label : '내용', value: 'content'}]
    };

    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleOpenSearch = this.handleOpenSearch.bind(this);
    this.handleCloseSearch = this.handleCloseSearch.bind(this);
    this.handleCloseSearchWithKey = this.handleCloseSearchWithKey.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.fetchTemplates = this.fetchTemplates.bind(this);
  }

  componentDidMount() {
    WindowEventHelper.add("keydown", this.handleCloseSearchWithKey);
  }

  componentWillUnmount() {
    WindowEventHelper.remove("keydown", this.handleCloseSearchWithKey)
  }

  componentWillReceiveProps(nextProps) {
    const { searchKeyword, searchType } = this.state;
    const nextSearchKeyword = nextProps.searchKeyword;
    const nextSearchType = nextProps.searchType;
    if(nextSearchKeyword === '' || (searchKeyword === nextSearchKeyword && searchType === nextSearchType)){
      this.setState({
        searching: false,
      });
    }
  }

  handleSelectAll(e) {
    const { handleSelectAllItems, handleDeselectAllItems } = this.props;
    if (e.target.checked) {
      handleSelectAllItems()
    } else {
      handleDeselectAllItems()
    }
  }

  handleToggleOption(e) {
    const { optionOpen } = this.state;

    this.setState({
      optionOpen: !optionOpen
    })
  }

  handleOpenSearch(e) {
    this.setState({
      searchOpen: true,
      searchKeyword:'',
      searchType: 'title',
    });
  }

  handleCloseSearch(e) {
    this.setState({
      searchOpen: false
    })
  }

  handleCloseSearchWithKey(e) {

    if (this.state.searchOpen) {
      if(e.keyCode === 27) {
        this.handleCloseSearch()
      }else if(e.keyCode === 13) {
        this.handleSearch();
        this.handleCloseSearch();
      }
    }
  }

  handleSearch() {

    const { searchKeyword, searchType } = this.state;

    let history = this.props.history;
    let location = this.props.location;

    if (searchKeyword.length > 0) {

      let listParams = parseListParams(location.search);
      if(listParams.searchKeyword !== searchKeyword || listParams.searchType !== searchType){
        history.push(location.pathname + "?" + querystring.stringify({searchKeyword: searchKeyword, searchType : searchType}));
        this.setState({
          searching: true,
        });
      }
    }
    this.handleCloseSearch();
  }

  handleDelete(e) {

    if (confirm('선택한 서식을 삭제하시겠습니까?')){

      const { items, dispatch, handleUpdateSelectedItems } = this.props;
      let ids = items.filter(item => item.selected).map(item => item.id);

      this.setState({
        deleting:true
      });
      handleUpdateSelectedItems({ deleting : true});
      fetch(addPrefix("/manage/templates.json"), {
        method: "delete",
        credentials: "include",
        headers: {'Content-Type':'application/x-www-form-urlencoded'},
        body: querystring.stringify({
          ids: ids.join(",")
        })
      })
        .then(jsonResponseHandler(dispatch))
        .then(data => {
          this.fetchTemplates();
        })
        .catch(r => {
          this.setState({
            optionOpen: false,
            deleting:false
          });
          handleUpdateSelectedItems({ deleting : false});
          console.error(r);
        })
    }
  }

  fetchTemplates() {

    const { dispatch } = this.props;

    fetch(addPrefix("/manage/templates.json") + location.search, {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        this.props.handleReceiveItems(data.items, data.totalCount);
        this.setState({
          optionOpen: false,
          deleting:false
        })
      })
      .catch(e => {
        console.log(e);
        this.setState({
          optionOpen: false,
          deleting:false
        })
      })
  }

  searchUpdated (value) {
    this.setState({searchKeyword: value})
  }

  @autobind
  selectSearchType(item, idx) {

    this.setState({
      searchType: item.value
    })
  }

  render() {

    const { searchOpen, searchKeyword, deleting, searching, searchTypeOptions, searchType  } = this.state;
    const { items } = this.props;

    let selectedCount = items.filter(item => item.selected).length;

    let optionAvailable = selectedCount > 0;

    if(searching) {
      return (
        <div className="wrap_search loading_search">
          <TSelectFilter className={"filter_search"} items={searchTypeOptions} disabled={true}
                         selected={searchType}
                         onSelect={(item, idx) => this.selectSearchType(item, idx)}/>
          <em className="txt_keyword">{searchKeyword}</em>
          <span className="txt_change">
            검색중
            <span className="ico_blog ico_change"/>
          </span>
        </div>
      )
    }

    return (
      <div className={classnames({
        "wrap_search": true,
        "on": searchOpen
      })}>
        <ItemAllCheckbox items={items} handleSelectAll={this.handleSelectAll}/>

        <EntryHeaderSearchButton
          searchOpen={searchOpen}
          searchKeyword={searchKeyword}
          searchType={searchType}
          searchTypeOptions={searchTypeOptions}
          onChangeSearchType={this.selectSearchType}
          onChangeKeyword={this.searchUpdated}
          onOpen={this.handleOpenSearch}
          onClose={this.handleCloseSearch}
          onSearch={this.handleSearch}
          placeholder={"서식 관리에서 검색합니다."}
        />

        <div className={classnames({
          "opt_blog": true,
          "change_on" : deleting
        })}>
          <button ref="btnOptionOpen" type="button" className="btn_opt" disabled={!optionAvailable} onClick={this.handleDelete}>
            삭제
          </button>
          <span className="txt_change">
            { deleting && "삭제중"}
            <span className="ico_blog ico_change"/>
          </span>
        </div>
      </div>
    )

  }
}

export default TemplateListHeader;
